import React from "react";
import { useNavigate } from "react-router-dom";
import { formatarMoeda } from "../../utils/calculos";
import {
  FluxoBar,
  FluxoCount,
  FluxoLabel,
  FluxoSection,
  FluxoSegment,
  FluxoSub,
  GargaloFlag,
  SectionHeader,
  SectionTitle,
} from "./styles";
import { rotaDaEtapa } from "./helpers";

function buildCols(wipPorEtapa) {
  if (!wipPorEtapa || wipPorEtapa.length === 0) return "repeat(6, 1fr)";
  const total = wipPorEtapa.reduce((sum, b) => sum + (b.count || 0), 0);
  if (total === 0) return "repeat(6, 1fr)";
  return wipPorEtapa
    .map((b) => `${Math.max(0.6, (b.count || 0) / total + 0.05)}fr`)
    .join(" ");
}

export default function WipFluxoBar({
  wipPorEtapa,
  gargaloEtapa,
  calibracaoCompleta,
  precosVisiveis,
}) {
  const navigate = useNavigate();
  const cols = buildCols(wipPorEtapa);

  return (
    <FluxoSection>
      <SectionHeader>
        <SectionTitle style={{ margin: 0 }}>Fluxo de produção · WIP por etapa</SectionTitle>
      </SectionHeader>
      <FluxoBar $cols={cols}>
        {(wipPorEtapa || []).map((bucket) => {
          const rota = rotaDaEtapa(bucket.etapa);
          const isGargalo = calibracaoCompleta && gargaloEtapa === bucket.etapa;
          return (
            <FluxoSegment
              key={bucket.etapa}
              type="button"
              onClick={() => rota && navigate(rota)}
              disabled={!rota}
              $bottleneck={isGargalo}
              title={`${bucket.label} — ${bucket.count} ambientes`}
            >
              {isGargalo && <GargaloFlag>Gargalo</GargaloFlag>}
              <FluxoLabel>{bucket.label}</FluxoLabel>
              <FluxoCount>{bucket.count}</FluxoCount>
              <FluxoSub>
                {precosVisiveis
                  ? formatarMoeda(bucket.valorRS || 0)
                  : "••••••"}
                {bucket.idadeMedia != null && (
                  <> · idade média {Math.round(bucket.idadeMedia)} du</>
                )}
              </FluxoSub>
            </FluxoSegment>
          );
        })}
      </FluxoBar>
    </FluxoSection>
  );
}
